<template>
  <div class="image-message">
    <a :href="getLinkToFile(file, 'INLINE')" target="_blank">
      <img :src="getLinkToFile(file, 'ATTACHMENT')">
      <div class="message-container">
        <div class="texts">
          <div class="imagename">
            <span>{{ file.originalName }}</span><br>
          </div>
       </div>
        <div class="download-container">
          <span class="meta">{{ t('labels_filesize') }}: {{ Math.round(file.size / 1024) }}Ko</span>
          <Icon
            class="download"
            :color="'#5bac26'"
            :width="24"
            :height="24"
            :art="'light'"
            :name="'arrow-circle-down'"
          />
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { split } from 'lodash'
import Icon from '../Icon'
import { useI36n } from '@jota-one/i36n/src/index.vue2'

export default {
  name: 'message-image',
  components: {
    Icon
  },
  props: ['file', 'message'],

  setup () {
    const { $label: t } = useI36n()

    return { t }
  },

  created () {
    setTimeout(() => {
      this.$emit('imageRendered')
    }, 100)
  },
  methods: {
    getLinkToFile (file, disposition) {
      if (file.links) {
        let link = file.links[0].href
        if (disposition === 'INLINE') link = file.links[1].href
        if (window._sanChatConfig.fileReplacePattern) {
          link = link.replace(window._sanChatConfig.fileReplacePattern, window._sanChatConfig.fileReplaceReplacement)
        }
        return link
      } else {
        let host = split(this.message.links[2].href, '/files/', 2)
        return host[0] + '/files/' + this.message.files[0].fileId + '/download/' + disposition
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.image-message {
  img {
    max-width: 100%;
  }
  .message-container {
    cursor: pointer;
    .texts {
      align-items: center;
      margin-bottom: 3px;
      color: var(--tw-c-original-green);
      button {
        color: inherit;
      }
      .imagename {
        padding-bottom: 5px;
        flex-grow: 1;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .download-container {
      display: flex;
      flex-direction: row;
      font-size: 13px;
      .meta {
        font-style: italic;
        font-weight: normal;
        margin: auto auto auto 0;
        color: var(--tw-c-medium-gray);
      }
      .download {
        margin: auto 0 auto auto;
      }
    }
  }
}
</style>
